<div class="content" [ngClass]="getClauseClass(content?.clauseType)">
  <span class="index">{{ content?.index }}</span>
  <div class="clause">
    <cars-tdif-content [content]="content?.content"></cars-tdif-content>
  </div>
</div>
